import React, {useState, useEffect} from "react";
import moment from "moment";
import {useLocaleContext} from "../../../../context/LocaleContext";
import Timeout from "../../../../components/Player/Overlay/Timeout";

const SUBTITLE_WAITING_STATUSES = {
    SUBTITLE: "subtitle",
    TIMEOUT: "timeout",
    STARTING: "starting",
    STOPPED: "stopped",
};

const MAX_TIMEOUT_MS = 2147483647;

const SubtitleWaitingSwitch = ({status, onChangeStatus, timeStart, pageName}) => {
    const {get} = useLocaleContext();
    const timeStartUnix = moment.unix(timeStart);

    switch (status) {
        case SUBTITLE_WAITING_STATUSES.TIMEOUT:
            return (
                <div className="subtitle-wrapper">
                    <p>{get(`${pageName}.overlay.waiting.title`)}</p>
                    <div className="subtitle-timeout-wrapper">
                        <Timeout
                            time={timeStartUnix}
                            onTimeoutOver={() => onChangeStatus(SUBTITLE_WAITING_STATUSES.STARTING)}
                        />
                    </div>
                </div>
            );
        case SUBTITLE_WAITING_STATUSES.SUBTITLE:
            return `${get(`${pageName}.overlay.starting.title`)} ${moment.unix(timeStart).format('LLL')} (UTC${moment.unix(timeStart).format('Z')})`;
        case SUBTITLE_WAITING_STATUSES.STARTING:
            return <p>{get(`${pageName}.overlay.starting.title`)}</p>;
        case SUBTITLE_WAITING_STATUSES.STOPPED:
            return <p>{get(`${pageName}.overlay.stopped.title`)}</p>;
        default:
            return null;
    }
}

const SubtitleWaiting = ({diffStartTimeout, isShowStopEvent, pageName, stream}) => {
    const [subtitleWaitingStatus, setSubtitleWaitingStatust] = useState(null);
    const timeStart = stream?.timeStart;
    const timeEnd = stream?.timeStop;

    const checkBroadcastStart = (currentTime, timeBroadcastStart, isTimeout) => {
        if (currentTime < timeBroadcastStart) {
            setSubtitleWaitingStatust(isTimeout ? SUBTITLE_WAITING_STATUSES.TIMEOUT : SUBTITLE_WAITING_STATUSES.SUBTITLE);
        } else {
            setSubtitleWaitingStatust(SUBTITLE_WAITING_STATUSES.STARTING);
        }
    }

    useEffect(() => {
        let timerStartId;
        let timerStopId;
        const currentTime = moment();
        const timeBroadcastStart = moment.unix(timeStart);

        if (!diffStartTimeout) {
            checkBroadcastStart(currentTime, timeBroadcastStart);
            return;
        }

        const timeStartTimeout = timeBroadcastStart.clone().subtract(diffStartTimeout);
        const diffTimeToTimeout = timeStartTimeout.diff(currentTime);

        if (diffTimeToTimeout >= 0) {
            setSubtitleWaitingStatust(SUBTITLE_WAITING_STATUSES.SUBTITLE);
            const timerDuration = Math.min(diffStartTimeout, MAX_TIMEOUT_MS);

            timerStartId = setTimeout(() => {
                setSubtitleWaitingStatust(SUBTITLE_WAITING_STATUSES.TIMEOUT);
            }, timerDuration);
        } else {
            checkBroadcastStart(currentTime, timeBroadcastStart, true);
        }

        if (isShowStopEvent) {
            const timeBroadcastStop = moment.unix(timeEnd);
            const diffTimeToStopped = timeBroadcastStop.diff(currentTime);

            if (diffTimeToStopped >= 0) {
                timerStopId = setTimeout(() => {
                    setSubtitleWaitingStatust(SUBTITLE_WAITING_STATUSES.STOPPED);
                }, diffTimeToStopped);
            } else {
                setSubtitleWaitingStatust(SUBTITLE_WAITING_STATUSES.STOPPED);
            }
        }

        return () => {
            if (timerStartId) {
                clearTimeout(timerStartId);
            }
            if (timerStopId) {
                clearTimeout(timerStopId);
            }
        }
    }, [timeStart, timeEnd, diffStartTimeout]);

    const onChangetSubtitleWaitingStatust = (status) => {
        setSubtitleWaitingStatust(status);
    }

    return (
        <SubtitleWaitingSwitch
            pageName={pageName}
            timeStart={timeStart}
            status={subtitleWaitingStatus}
            onChangeStatus={onChangetSubtitleWaitingStatust}
        />
    )
}

export default SubtitleWaiting;
